<div class="divBackground" (click)="touchCloseModal()">

  <div class="divCentral">
  <ion-img src="../../../assets/image/aceleramovel_horizontal.svg"></ion-img>
  </div>

</div>
